import React from 'react';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import Trailer from './Trailer';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

// This is the query that Apollo Client will send to the WP site.
const PAGE_QUERY = gql`
query GET_PAGE($uri: String) {
  pageBy(uri: $uri) {
    pageId
    title
    content(format: RENDERED)
  }
}
`;

function About() {
	const { loading, error, data } = useQuery(PAGE_QUERY, {
		variables: { 
			'uri': 'about'
		},
	});

	if (loading) return 'Loading...';
	if (error) return `Error! ${error.message}`;

	function createMarkup(markup) {
		return { __html: markup };
	}

	return (
		<section className="region about" id="what">
			<h2><FontAwesomeIcon icon={faEdit} /> About</h2>
			<Trailer />
			<div className="container">
				<div className="content" dangerouslySetInnerHTML={createMarkup(data.pageBy.content)}></div>
			</div>
		</section>)
}
export default About;
